import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import firebaseWebConfig from "./firebaseWebConfig.json";

const app = initializeApp(firebaseWebConfig);

export const auth = getAuth(app);
